import { render, staticRenderFns } from "./CompletedInventoryRequest.vue?vue&type=template&id=2da22c08&scoped=true&"
import script from "./CompletedInventoryRequest.vue?vue&type=script&lang=js&"
export * from "./CompletedInventoryRequest.vue?vue&type=script&lang=js&"
import style0 from "./CompletedInventoryRequest.vue?vue&type=style&index=0&id=2da22c08&prod&lang=scss&scoped=true&"
import style1 from "./CompletedInventoryRequest.vue?vue&type=style&index=1&id=2da22c08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da22c08",
  null
  
)

export default component.exports